export default __webpack_public_path__ + "static/media/1767.e840f930.png";